import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'

export class WidgetApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string) {
    this.fetchInstance = new Fetch(endpoint, token)
  }

  requestWidgetUrl = async (req: any) => {
    return this.fetchInstance.post(ApiEndpoints.WIDGET_URLS, req).then((data) => data.widget_url)
  }
}
